// extracted by mini-css-extract-plugin
export var divider = "_m8-0";
export var labelWrapper = "_m8-2";
export var lineSvg = "_m8-1";